import { jsxs, jsx } from 'react/jsx-runtime';
import Button from '../../Button/Button.js';
import FeedbackPanel, { FeedbackPanelType } from '../FeedbackModal/FeedbackPanel.js';
import Header from './Header.js';
import Body from './Body.js';
import Footer from './Footer.js';
import Item from './Item.js';
import { Emphasis } from '../../../types.js';

/**
Un item di tipo Feedback di `Modal` usato  per chiedere la conferma di lettura di un messaggio.

_Quando si utilizza?_
Può essere utile all'interno di un processo in cui accadono eventi che richiedono una particolare attenzione.

Tramite la modale di feedback si possono veicolare 4 tipologie di messaggi:

- _Informazione_: per comunicare un'informazione utile.
- _Successo_: per informare che qualcosa è avvenuto correttamente.
- _Attenzione_: per avvertire l'utente di una condizione che potrebbe causare problemi in futuro.
- _Allarme/Errore_: per avvertire l'utente di un problema/errore presente.

Con questa, che contiene al suo interno il pulsante "Ho capito",
interrompiamo il flusso di lavoro dell'utente e gli chiediamo di prendere atto di ciò che sta leggendo.

_Attenzione_:
dobbiamo interrompere nel miglior modo possibile e solo quando è veramente necessario,
altrimenti si corre il rischio che l'utente, tempestato di messaggi e popup, che compaiono ad ogni occasione,
si infastidisca, non legga e clicchi subito sul pulsante "Ho capito" senza neanche pensarci su.

Per una questione di facilità di lettura e comprensione i messaggi devono essere sintetici.
Può esserti utile consultare la sezione dedicata ai Testi. Si può anche inserire un link a maggiori dettagli.
*/
function FeedbackItem({ id, modalTitle = ' ', buttonLabel = 'Ho capito', onClose, type = FeedbackPanelType.info, title, message = '', className, icon, classNameBody, keepAliveWhenHidden = true, }) {
    return (jsxs(Item, { id: id, className: className, keepAliveWhenHidden: keepAliveWhenHidden, children: [modalTitle && jsx(Header, { children: modalTitle }), jsx(Body, { className: classNameBody, children: jsx(FeedbackPanel, { type: type, title: title, message: message, icon: icon }) }), jsx(Footer, { children: jsx(Button, { emphasis: Emphasis.HIGH, primary: true, onClick: onClose, children: buttonLabel }) })] }));
}

export { FeedbackItem as default };
